import Modal from 'modules/Modal';


export default (function() {

	function init(links, modal) {
		Modal.init(links, modal, populateModal);
	}

	function populateModal(attribute, modal) {
		const productAttribute   = $(attribute).data('product-attribute');
		const modalTitle          = $(modal).find('.js-modal-title');
		const modalContent        = $(modal).find('.js-modal-content');

		$.ajax({
			url : `${window.theme.ajax_url}`,
			type : 'post',
			data : {
				action    : 'product_show_attribute',
				product_attribute : productAttribute
			},
			dataType: 'json',
			beforeSend: () => {
				$(modal).addClass('is-loading');
				modalTitle.empty();
				modalContent.empty();
			},
			success: (data) => {
				$(modal).removeClass('is-loading');
				modalTitle.hide().html(data.title).fadeIn(200);
				modalContent.hide().append(data.picture, data.content).fadeIn(200);
			},
			error: (jqXHR, error) => {
				console.log(jqXHR, error);
				$(modal).removeClass('is-loading');
			}
		});
	}

	return {
		init
	};
})();